/**
 * Module Staff #07 — Customer Success & NPS
 */
const moduleStaffCS = {
  id: 'staff-customer-success',
  population: 'staff',
  order: 7,
  category: 'Qualité',
  title: 'Customer Success & NPS',
  subtitle: 'Anticiper le churn, exploiter les retours, fidéliser',
  icon: 'Award',
  duration: '20 min',
  level: 'Intermédiaire',
  audience: 'Customer Success Managers',
  slides: [
    { type: 'cover', eyebrow: 'Module 07 — Staff', title: 'Customer Success & NPS', subtitle: 'Anticiper, comprendre, fidéliser', icon: 'Award', duration: '20 min', audience: 'CSM', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'Le rôle CSM est essentiel pour la rétention client. Ce module vous donne les bons outils et workflows.', objectives: [
      'Lire le dashboard Customer Success et ses alertes',
      'Interpréter le NPS et identifier les Détracteurs',
      'Lancer une démarche de récupération sous 48 h',
      'Identifier les signaux faibles de churn',
      'Exploiter les commentaires d\'évaluation',
      'Maintenir le NPS Baobab > 50',
    ]},
    { type: 'concept', eyebrow: 'Alertes CS', icon: 'BookOpen', title: 'Les 4 signaux de churn',
      bullets: [
        '📉 Baisse volume : -30 % sur 30 j vs trimestre précédent',
        '⚠️ NPS Détracteur : note < 7 (2 fois consécutives = critique)',
        '⏱️ DSO en hausse : paiements de plus en plus tardifs',
        '📞 Silence : pas d\'activité ni de contact > 60 j',
      ],
      note: 'Le dashboard CS détecte automatiquement ces signaux et déclenche des alertes.',
    },
    { type: 'steps', title: 'Récupération d\'un Détracteur sous 48 h', steps: [
      { title: 'Alerte reçue dans le dashboard CS', detail: 'Notification + email automatique.' },
      { title: 'Lire le commentaire d\'évaluation', detail: 'Contexte précis du mécontentement.' },
      { title: 'Appeler le client (pas email)', detail: 'Téléphone direct, dans les 24 h.' },
      { title: 'Écouter activement', detail: 'Reformuler, valider la compréhension.' },
      { title: 'Proposer une action concrète', detail: 'Geste commercial, échange d\'opérateur, suivi rapproché.' },
      { title: 'Tracer l\'action dans le CRM', detail: 'Champ "Plan d\'action récupération" sur la fiche client.' },
      { title: 'Suivi à J+15', detail: 'Vérifier l\'amélioration via nouvelle évaluation.' },
    ]},
    { type: 'comparison', title: 'CSM : do vs don\'t', do: [
      'Appeler proactivement, pas attendre la plainte',
      'Lire chaque commentaire d\'évaluation (oui, tous)',
      'Documenter dans le CRM systématiquement',
      'Coordonner avec opérations et commerciaux',
      'Mesurer l\'évolution NPS par client',
    ], dont: [
      'Ne pas se contenter d\'email pour les Détracteurs',
      'Ne pas promettre ce que vous ne pouvez tenir',
      'Ne pas être défensif face à une critique',
      'Ne pas ignorer les silences (signal faible)',
      'Ne pas oublier le suivi à J+15',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Le NPS d\'un client critique passe de 8 à 5. Quelle action immédiate ?',
      options: [
        'Attendre la 2e note pour confirmer',
        'Appeler le client sous 24h pour comprendre',
        'Lui envoyer une remise',
        'Le supprimer du suivi',
      ],
      answerIndex: 1,
      explanation: 'Une chute de 3 points est un signal fort. L\'appel rapide démontre que vous prenez son retour au sérieux. La remise sans diagnostic = mauvaise pratique.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '4 signaux à surveiller : volume, NPS, DSO, silence.',
      'Détracteur = action sous 48 h, par téléphone.',
      'Documentation CRM = mémoire collective.',
      'Suivi J+15 = boucle de validation.',
      'NPS > 50 = excellent secteur logistique.',
    ]},
    { type: 'cta', title: 'Module 07 terminé !', actions: [
      { label: 'Dashboard CS', href: '/admin/customer-success' },
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffCS;
